import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'

import { ErrorPage } from '@/pages/error/ErrorPage'
import { TrackingService } from '@/shared/lib/tracking'
import { Sentry } from '../sentry'

import '../i18n/i18n.ts'
import { RoutingComponent } from '../navigation/RoutingComponent'
import { UnauthenticatedProviders } from '../providers'
import '../styles/index.css'
import '../styles/print.css'
import '../versions/versionListener.ts'
import { DocumentsProvider } from '@/shared/firebase/hooks/useDocument.tsx'
import { HotelAvailabilityProvider } from '@/components/HotelAvailabilityContext.tsx'
import { PricingPeriodProvider } from '@/shared/providers/PricingPeriodProvider.tsx'

TrackingService.init()

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <Sentry.ErrorBoundary
            fallback={<ErrorPage />}
            showDialog
        >
            <DocumentsProvider>
                <UnauthenticatedProviders>
                    <PricingPeriodProvider>
                        <HotelAvailabilityProvider>
                            <BrowserRouter>
                                <RoutingComponent />
                            </BrowserRouter>
                        </HotelAvailabilityProvider>
                    </PricingPeriodProvider>
                </UnauthenticatedProviders>
            </DocumentsProvider>
        </Sentry.ErrorBoundary>
    </React.StrictMode>,
)
